/**
 * Custom hook for Dashboard Aggregations data fetching
 */

import { useState, useCallback, useEffect } from "react";
import { DashboardAggregations, AuditLogFilters } from "./types";
import auditLogsApiService from "./auditLogsApiService";

export const useDashboardAggregations = (
  filters: AuditLogFilters,
  autoFetch: boolean = true
) => {
  const [data, setData] = useState<DashboardAggregations | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const fetchData = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await auditLogsApiService.getDashboardAggregations(filters);
      setData(response);
    } catch (err) {
      const errorMessage = err instanceof Error ? err.message : "Failed to fetch dashboard data";
      setError(errorMessage);
      console.error("Error fetching dashboard aggregations:", err);
    } finally {
      setLoading(false);
    }
  }, [filters]);

  useEffect(() => {
    if (autoFetch) {
      fetchData();
    }
  }, [filters, autoFetch, fetchData]);

  return {
    data,
    loading,
    error,
    refetch: fetchData,
  };
};

export default useDashboardAggregations;
